import _kebabCase from 'lodash/kebabCase';

export const getReportMapForGroup = reports =>
  reports.reduce((acc, { ReportId: id, Image: imageUrl, Page: url, Title: title }) => {
    const reportId = _kebabCase(title);
    return {
      ...acc,
      [reportId]: {
        id,
        pageUrl: `reports/${reportId}`,
        reportUrl: `/aware/?embed=1&detailsSrc=/aware/reports/${encodeURIComponent(url)}`,
        imageUrl: `/aware/images/reports/${imageUrl}`,
        title
      }
    };
  }, {});

/**
 * For some reason the chosen library sets the width of the chosen-container div to 0px if it's
 * not expanded by default _and_ because this page is loaded within an iframe document.ready
 * never gets called, so we have to do it ourselves
 */
export const addWidthToCustomSelectElements = iframe => {
  try {
    const frameNodeContentDocument =
      iframe.contentDocument.getElementById('detailsec1').contentDocument;

    const chosenContainerList =
      frameNodeContentDocument.getElementsByClassName('chosen-container');

    if (chosenContainerList.length) {
      [...chosenContainerList].forEach(node => {
        // eslint-disable-next-line no-param-reassign
        node.style.width = '100%';
      });
    }
  } catch {
    setTimeout(() => addWidthToCustomSelectElements(iframe), 500);
  }
};
